import {
  TaskAssignment,
  AssignmentLifecycleStage,
  TaskAssignmentStatus,
} from 'edrolo/domains/coursePortal/types/Task';
import Waffle from 'edrolo/utils/Waffle';

const taskMgmtIsActive = Waffle.flag_is_active('task_mgmt');

export const getAssignmentMeta = (assignment: TaskAssignment) => {
  const notStarted =
    assignment.resolved_stage === AssignmentLifecycleStage.NOT_STARTED;
  const inProgress =
    assignment.resolved_stage === AssignmentLifecycleStage.IN_PROGRESS;
  const isCompleted =
    assignment.resolved_stage === AssignmentLifecycleStage.COMPLETED;
  const isClosed =
    assignment.resolved_stage === AssignmentLifecycleStage.CLOSED;
  const isArchived =
    assignment.resolved_stage === AssignmentLifecycleStage.ARCHIVED;

  const legacyNotStarted =
    assignment.completion_status === TaskAssignmentStatus.NOT_STARTED;
  const legacyInProgress =
    assignment.completion_status === TaskAssignmentStatus.IN_PROGRESS;
  const legacyIsCompleted =
    assignment.completion_status === TaskAssignmentStatus.COMPLETED;

  return {
    notStarted: taskMgmtIsActive ? notStarted : legacyNotStarted,
    inProgress: taskMgmtIsActive ? inProgress : legacyInProgress,
    isCompleted: taskMgmtIsActive ? isCompleted : legacyIsCompleted,
    isClosed: taskMgmtIsActive ? isClosed : false,
    isArchived: taskMgmtIsActive ? isArchived : false,
  };
};
